import { checkAuth } from './auth';
import {
    GET_COUNTRIES_REQUEST,
    GET_TEMPLATE_REQUEST,
    GET_TEMPLATES_REQUEST,
    MAKE_TEMPLATE_REQUEST,
    GET_TEMPLATE_SUCCESS,
    GET_TEMPLATE_FAILURE,
} from '../actionTypes';

export const getCountries = () => ({
    type: GET_COUNTRIES_REQUEST,
});

export const getTemplates = () => ({
    type: GET_TEMPLATES_REQUEST,
});

export const getTemplate = (id) => ({
    id,
    type: GET_TEMPLATE_REQUEST,
});

export const getTemplateSuccess = (payload) => ({
    payload,
    type: GET_TEMPLATE_SUCCESS,
});

export const getTemplateFailure = (payload) => ({
    payload,
    type: GET_TEMPLATE_FAILURE,
});

export const makeTemplate = (template, siteId) =>
    checkAuth({
        siteId,
        template,
        type: MAKE_TEMPLATE_REQUEST,
    });
